// extracted by mini-css-extract-plugin
export var container = "_al-0";
export var icon = "_al-1";
export var text = "_al-2";